import { SelectMenu, Typography } from '@scale/scaleui';

export const ObjectivityQuestion = ({
  selectedIsObjective,
  setSelectedIsObjective,
}: {
  selectedIsObjective: boolean;
  setSelectedIsObjective: (value: boolean) => void;
}) => {
  return (
    <div className="flex flex-row gap-2 items-center my-4">
      <Typography.Subtitle3 className="flex items-center gap-2">
        Is one response objectively better than the other(s)? (required)
      </Typography.Subtitle3>

      <SelectMenu
        className="flex flex-row justify-between"
        placeholder="Select an option"
        options={[
          {
            id: 'true',
            name: 'Yes',
          },
          {
            id: 'false',
            name: 'No',
          },
        ]}
        selectedOptionId={
          selectedIsObjective === true ? 'true' : selectedIsObjective === false ? 'false' : ''
        }
        setSelected={selectedOptionId => {
          const objectiveResponse = selectedOptionId === 'true';
          setSelectedIsObjective(objectiveResponse);
        }}
      />
    </div>
  );
};
